'use strict';

module.exports = {

  matches: require('./matches'),

  height: require('./height'),

  width: require('./width'),

  offset: require('./offset'),

  offsetParent: require('./offsetParent'),

  position: require('./position'),

  contains: require('./contains'),

  scrollParent: require('./scrollParent'),

  scrollTop: require('./scrollTop'),

  querySelectorAll: require('./querySelectorAll'),

  closest: require('./closest')
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/query/index.js
 ** module id = 59
 ** module chunks = 0
 **/